import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ClientsAccountsRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		if (!this.accountService.isAgency) {
			this.navigationService.replaceRoute('clients.performance');
		}
	}
}
